"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLabel = _interopRequireDefault(require("../control-label"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propNames = ['id', 'options', 'value', 'onChange', 'label', 'optional', 'aside', 'disabled', 'validationError', 'themeControlSelect', 'themeControlSelectContainer', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

var ControlSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ControlSelect, _React$Component);

  function ControlSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ControlSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ControlSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      return _this.props.onChange(e.target.value, _this.props.id);
    });

    return _this;
  }

  _createClass(ControlSelect, [{
    key: "render",
    value: function render() {
      var extraProps = (0, _omit.default)(this.props, propNames);
      var _this$props = this.props,
          id = _this$props.id,
          value = _this$props.value,
          label = _this$props.label,
          options = _this$props.options,
          optional = _this$props.optional,
          aside = _this$props.aside,
          disabled = _this$props.disabled,
          validationError = _this$props.validationError,
          themeControlSelectContainer = _this$props.themeControlSelectContainer,
          themeControlSelect = _this$props.themeControlSelect,
          themeControlWrapper = _this$props.themeControlWrapper,
          themeLabel = _this$props.themeLabel;
      var selectProps = {
        id: id,
        disabled: disabled,
        value: value,
        className: "select ".concat(themeControlSelect),
        onChange: this.onChange,
        'aria-required': optional ? false : true,
        'data-test': "".concat(id, "-select")
      };

      if (validationError) {
        selectProps['aria-invalid'] = true;
      }

      var renderOptions = function renderOptions(d) {
        if (d.options) {
          return _react.default.createElement("optgroup", {
            key: d.label,
            label: d.label
          }, d.options.map(renderOptions));
        } else {
          return _react.default.createElement("option", {
            disabled: d.disabled,
            key: d.value,
            value: d.value
          }, d.label);
        }
      };

      return _react.default.createElement(_controlWrapper.default, {
        id: id,
        themeControlWrapper: themeControlWrapper,
        validationError: validationError
      }, label && _react.default.createElement(_controlLabel.default, {
        text: label,
        id: id,
        aside: aside,
        optional: optional,
        themeLabel: themeLabel
      }), _react.default.createElement("div", {
        className: "select-container ".concat(themeControlSelectContainer)
      }, _react.default.createElement("select", _extends({}, selectProps, extraProps), options.map(renderOptions)), _react.default.createElement("div", {
        className: "select-arrow"
      })));
    }
  }]);

  return ControlSelect;
}(_react.default.Component);

exports.default = ControlSelect;

_defineProperty(ControlSelect, "propTypes", {
  /** Identifying value for input element. */
  id: _propTypes.default.string.isRequired,

  /** An array of objects containing `label` `value` key value pairings to represent each option. An optional `disable` key can be provided to disable the selection of an indiviual `<option>`. If `value` is not present but an `options` array is provided containing the same `label` `value` key value pairings, options will be grouped within a `<optgroup>` element as defined by `label` child key. Note that each `label` value must be unique. */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: function value(props, propName, componentName) {
      if (!props.value && typeof props.value !== 'string' && !props.hasOwnProperty('options')) {
        return new Error("The prop \"".concat(propName, "\" is required in ").concat(componentName, " if a options array is not provided for select groups."));
      } else if (props.value && typeof props.value !== 'number' && typeof props.value !== 'string') {
        return new Error("".concat(props.value, " of type ").concat(_typeof(props.value), " supplied to ").concat(componentName, ", expected a number or string."));
      } else if (props.hasOwnProperty('value') && props.hasOwnProperty('options')) {
        return new Error("You've provided both an 'options' & 'value' key to one of your options object groups. Only 'options' will be used.");
      }
    },
    disabled: _propTypes.default.bool,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      value: _propTypes.default.string,
      disabled: _propTypes.default.bool
    }))
  })).isRequired,

  /** Input value */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Called during changes to the input element. */
  onChange: _propTypes.default.func.isRequired,

  /** Value passed to the label element. */
  label: _propTypes.default.string,

  /** If provided the text, "(optional)" is appended to the value of the label element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** Pass disabled attribute */
  disabled: _propTypes.default.bool,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /** Assembly classes to apply to the select element */
  themeControlSelect: _propTypes.default.string,

  /** Assembly classes to apply to the select container */
  themeControlSelectContainer: _propTypes.default.string,

  /** Assembly classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** Assembly classes to apply to the label element */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlSelect, "defaultProps", {
  value: '',
  optional: false,
  disabled: false,
  themeControlSelectContainer: '',
  themeControlSelect: ''
});